/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_InstructionsInputs */

const en_admin_resource_form_instructions = /** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

const de_admin_resource_form_instructions = /** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anweisungen`)
};

const es_admin_resource_form_instructions = /** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones`)
};

const fr_admin_resource_form_instructions = /** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

const nl_admin_resource_form_instructions = /** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructies`)
};

/** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */
const it_admin_resource_form_instructions = en_admin_resource_form_instructions;

/** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_instructions = en_admin_resource_form_instructions;

/** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */
const pl_admin_resource_form_instructions = en_admin_resource_form_instructions;

/** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */
const hu_admin_resource_form_instructions = en_admin_resource_form_instructions;

/** @type {(inputs: Admin_Resource_Form_InstructionsInputs) => LocalizedString} */
const ro_admin_resource_form_instructions = en_admin_resource_form_instructions;

/**
* | output |
* | --- |
* | "Instructions" |
*
* @param {Admin_Resource_Form_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_instructions = /** @type {((inputs?: Admin_Resource_Form_InstructionsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_InstructionsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_instructions(inputs)
	if (locale === "de") return de_admin_resource_form_instructions(inputs)
	if (locale === "es") return es_admin_resource_form_instructions(inputs)
	if (locale === "fr") return fr_admin_resource_form_instructions(inputs)
	if (locale === "nl") return nl_admin_resource_form_instructions(inputs)
	if (locale === "it") return it_admin_resource_form_instructions(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_instructions(inputs)
	if (locale === "pl") return pl_admin_resource_form_instructions(inputs)
	if (locale === "hu") return hu_admin_resource_form_instructions(inputs)
	return ro_admin_resource_form_instructions(inputs)
});
export { admin_resource_form_instructions as "admin.resource_form.instructions" }